import { ILoggerOutput, LogLevel } from "./logger";

export class ConsoleLogger implements ILoggerOutput {
    constructor(
        private readonly name: string,
        private readonly minLevel: number
    ) { }

    exception(error: unknown) {
        this.log(LogLevel.error, [error]);
    }

    log(level: LogLevel, args: any[]) {
        if (level < this.minLevel) {
            return;
        }

        (console[LogLevel[level] as keyof typeof console] as typeof console.log)(...args);
    }
}
